import { useContext } from 'react';
import PropTypes from 'prop-types';
import TextInputWithButton from 'components/ui-components/TextInputWithButton';
import { Controller } from 'react-hook-form';
import { HookFormContext } from 'components/cef_form/hook-form/providers/HookFormProvider';
import provideHookFormFieldErrors from 'utils/hook-form/provideHookFormErrors';

/** Important
 * The disabled prop should be a state dependent variable,
 * this way the button can disable/enable when a calls been made/resolved
 */

const HookFormTextInputWithButton = ({
  className,
  id,
  label,
  description,
  placeholder,
  value,
  hideControls,
  buttonClassName,
  buttonText,
  rules,
  onClick,
  disabled,
}) => {
  const { control, errors, handleBlur } = useContext(HookFormContext);

  return (
    <Controller
      name={id}
      control={control}
      rules={rules}
      render={({ field }) => (
        <TextInputWithButton
          className={className}
          id={id}
          label={label}
          description={description}
          placeholder={placeholder}
          value={value}
          hideControls={hideControls}
          buttonClassName={buttonClassName}
          buttonText={buttonText}
          onChange={field.onChange}
          onBlur={handleBlur ? () => handleBlur(id) : undefined}
          onClick={onClick}
          disabled={disabled}
          errors={
            Object.keys(errors).length
              ? provideHookFormFieldErrors(id, errors)
              : null
          }
        />
      )}
    />
  );
};

HookFormTextInputWithButton.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  hideControls: PropTypes.bool,
  buttonClassName: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  rules: PropTypes.object,
  onClick: PropTypes.func,
  disabled: PropTypes.bool.isRequired,
};

export default HookFormTextInputWithButton;
